export function getApi() {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;
    
    // 如果是本地开发，返回固定的
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        // 本地开发时，可以根据需要修改
        // return 'https://admin.xueli1.cn';
        return 'http://admin.fastxuexin.com';
		
    }
    
    // 通用处理：将当前域名的第一个子域名替换为 'admin'
    const domainParts = hostname.split('.');
    
    // 确保域名至少有2部分（如 example.com）
    if (domainParts.length >= 2) {
        // 替换第一个部分为 'admin'
        domainParts[0] = 'admin';
        const newHostname = domainParts.join('.');
        
        // 如果有端口号，需要带上端口号（通常不需要，因为admin域名一般默认端口）
        // 但为了完整性，可以加上
        const portStr = port ? `:${port}` : '';
        
        return `${protocol}//${newHostname}${portStr}`;
    }
    
    // 如果域名解析失败，返回默认的（添加admin前缀）
    return `${protocol}//admin.${hostname}`;
}